export default class BDialogTrigger
{
	constructor(el)
	{
		this.el = el;
	}

	static initialize()
	{
		this.addEventListeners();
	}

	static addEventListeners()
	{
		document.addEventListener("click", event => {
			const selector = `[data-dialog-selector]`;
			if (event.target.matches(`${selector}, ${selector} *`)) {
				event.preventDefault();

				new this(event.target.closest(`${selector}`)).openModal();
			}
		});

		document.addEventListener("click", event => {
			if (event.target.matches(`.dialog .close-button, .dialog .close-button *, .dialog__close-button`)) {
				event.target.closest(`dialog`).close();
			}
		});
	}

	openModal()
	{
		document.querySelector(this.el.dataset.dialogSelector).showModal();
	}
}
